@if(showStatus) {
<td>
  <div class="flex items-center justify-center">
    @if(user.hasAlert) {
    <i class="pi pi-circle-fill text-xs text-red-500"></i>
    } @else {
    <i class="pi pi-blank text-xs"></i>
    }
  </div>
</td>
}
<td>
  <div class="flex flex-col gap-1">
    <div class="flex items-center justify-between gap-1">
      <span class="text-base">{{ user.name}}</span>
    </div>
    <div class="flex items-center gap-1 text-xs">
      <span>{{ 'lastAccess' | translate }}:</span>
      <span>{{ user.logInfo | statusDate }}</span>
    </div>
  </div>
</td>
<td>
  <div class="text-row flex items-center justify-center">{{ user.metrics.date | dateOnly }}</div>
</td>
<td>
  <div class="flex flex-col text-xs">
    <div class="text-row flex gap-1">
      <span>{{ 'parameters.duration' | translate }}:</span>
      <span class="justify-self-end">{{ user.metrics.minutesTot | duration }}</span>
    </div>

    <div class="flex items-end justify-between">
      <div class="flex flex-col">
        <span>{{ 'parameters.rest' | translate }}</span>
        <i class="pi pi-sort-down-fill text-(--color-rest)"></i>
      </div>
      <div class="flex flex-col items-end">
        <span>{{ 'parameters.movement' | translate }}</span>
        <i class="pi pi-sort-down-fill text-(--color-movement)"></i>
      </div>
    </div>
    <p-progressbar [value]="getPercentage(movPercentage)" showValue="false"
                   [pt]="{
                        root: 'h-1.5! rounded-full! bg-(--color-movement)!',
                        value: 'bg-(--color-rest)!'
                     }" />
  </div>
</td>
<td class="content-center">
  <div class="grid grid-cols-1 items-center gap-y-1 text-xs">
    <span class="text-row">{{ 'parameters.rest' | translate }}:</span>

    <span class="text-row">{{ 'parameters.movement' | translate }}:</span>
  </div>
</td>

<td class="content-center">
  <div class="grid grid-cols-1 gap-y-1 text-xs">
    <div class="grid grid-cols-2 items-center">
      <app-threshold-indicator class="justify-self-center" [value]="user.metrics.fcrValue" type="FC" />
      <app-trend-indicator class="justify-self-center" [value]="user.metrics.fcrDelta" type="FC" />
    </div>

    <div class="grid grid-cols-2 items-center">
      <app-threshold-indicator class="justify-self-center" [value]="user.metrics.fcmValue" type="FC" />
      <app-trend-indicator class="justify-self-center" [value]="user.metrics.fcmDelta" type="FC" />
    </div>
  </div>
</td>
<td class="content-center">
  <div class="grid grid-cols-1 gap-y-1 text-xs">
    <div class="grid grid-cols-2 items-center">
      <app-threshold-indicator class="justify-self-center" [value]="user.metrics.frrValue" type="FR" />
      <app-trend-indicator class="justify-self-center" [value]="user.metrics.frrDelta" type="FR" />
    </div>

    <div class="grid grid-cols-2 items-center">
      <app-threshold-indicator class="justify-self-center" [value]="user.metrics.frmValue" type="FR" />
      <app-trend-indicator class="justify-self-center" [value]="user.metrics.frmDelta" type="FR" />
    </div>
  </div>
</td>
@if(showSteps) {
<td class="align-top">
  <div class="flex justify-center">
    <span class="text-row">{{ user.metrics.stepsValue }}</span>
  </div>
</td>
}
<td>
  <div class="flex flex-col items-center justify-center">
    @if (user.reportType !== '' && user.reportType !== null) {
    <div class="text-row flex items-center justify-center gap-1.5 rounded bg-(--color-report) p-1.5">
      <i class="pi pi-file-pdf"></i>
      <span>{{ user.reportType | translate }}</span>
    </div>
    }
    <span class="text-xs">{{ user.lastReport | statusDate }}</span>
  </div>
</td>
<td>
  <div class="flex items-center justify-end">
    <p-button icon="pi pi-arrow-right" variant="outlined" (click)="onShowUser(user)" />
  </div>
</td>
